import 'chosen-js';
import { generateAccreditationCertificate } from './scripts/certificate-generator.js';

// Localized Script Keys
const REST_URL_KEY = 'resturl';
const REST_NONCE_KEY = 'restnonce';

var rrspClient = rrspClient || {};

/*	-----------------------------------------------------------------------------------------------
	Set Active Sidebar Item
--------------------------------------------------------------------------------------------------- */
rrspClient.setSidebarPageActive = {
    init() {
        if( typeof pagemeta !== 'undefined' ) {
            if( typeof pagemeta.page_title !== 'undefined' ) {
                let el = $("#side-menu").find(`[data-navitem='${pagemeta.page_title}']`);
                el.addClass('active');
            }
        }
    }
}

/*	-----------------------------------------------------------------------------------------------
	Set Active Nav Item
--------------------------------------------------------------------------------------------------- */
rrspClient.setNavPageActive = {
    init() {
        if( typeof pagemeta !== 'undefined' ) {
            if( typeof pagemeta.page_title !== 'undefined' ) {
                let el = $("#nav-menu").find(`[data-navitem='${pagemeta.page_title}']`);
                el.addClass('active');
            }
        }
    }
}

/*	-----------------------------------------------------------------------------------------------
	Expandable Table
--------------------------------------------------------------------------------------------------- */
rrspClient.expandableTable = {
    init() {
        this.setEventListeners();
    },

    setEventListeners() {
        $('table.table-expandable-progress tr.section-header-row').on('click', function() {
            $(this).parent().next('tbody.standard-body').toggle();
            $(this).find('td.section-header').find('.expand-icon').toggleClass('fa-caret-right fa-caret-down');
        });
    }
}

/*	-----------------------------------------------------------------------------------------------
	Enhanced Multi-Select
--------------------------------------------------------------------------------------------------- */
rrspClient.enhancedMultiSelect = {
    init() {
        this.initializeChosen();
    },
    
    initializeChosen() {
        // Apply Chosen to all multiple selects
        $('select[multiple]').chosen({
            width: '100%',
            placeholder_text_multiple: "Select option(s)",
            no_results_text: "No results match"
        });
        
        // Specific initialization for the state licenses field
        $('#field_ogdar').chosen({
            width: '100%', 
            placeholder_text_multiple: "Select State(s)",
            no_results_text: "No states match"
        });
    }
}


/*	-----------------------------------------------------------------------------------------------
	Tooltips
--------------------------------------------------------------------------------------------------- */
rrspClient.tooltips = {
    init() {
        $('[data-toggle="tooltip"]').tooltip();
    }
}


/*	-----------------------------------------------------------------------------------------------
	Notification banner at the top
--------------------------------------------------------------------------------------------------- */
rrspClient.notificationBanner = {
    init() {
        this.setListeners();
        this.maybeNotifyAccountApproval();
        this.maybeNotifyOnHold();
    },

    setListeners() {
        $('#proBanner #bannerClose').on('click', function() {
            $('#proBanner').addClass('d-n');
        });
    },

    maybeNotifyAccountApproval() {
        if( typeof taskdata !== 'undefined' ) {
            if( taskdata.account_approval.status == 1 ) {
                console.log('account_approval', taskdata.account_approval);
                let notification = 'Your account is now pending administrator approval. For more details, please contact RadSite.';
                $('#proBanner').removeClass('d-n');
                $('#proBanner').find('#pbAnnouncement').html(notification);
            }
        }
    },

    maybeNotifyOnHold() {
        if( typeof taskdata !== 'undefined' ) {
            if( taskdata.payment_status.status == "3" ) {
                let notification = 'Your application is on-hold until an administrator approves your pending payment. For more details, please contact RadSite.';
                $('#proBanner').removeClass('d-n');
                $('#proBanner').find('#pbAnnouncement').html(notification);
            }
        }
    }

}

/*	-----------------------------------------------------------------------------------------------
	Toggle Entity Activation
--------------------------------------------------------------------------------------------------- */
rrspClient.toggleActivation = {
    init() {
        this.setEventListeners();
    },

    setEventListeners() {
        // Listen for click on toggle activation buttons
        $('#toggle-activation-btn').on('click', function() {
            const button = $(this);
            const entityId = button.data('entity-id');
            const action = button.data('action');
            
            // Confirm before proceeding
            if (!confirm('Are you sure you want to ' + action + ' this item?')) {
                return;
            }
            
            // Disable button and show loading state
            button.prop('disabled', true);
            const originalHtml = button.html();
            button.html('<i class="fa fa-spinner fa-spin"></i> ' + (action === 'activate' ? 'Activating...' : 'Deactivating...'));
            
            // Make AJAX request
            $.ajax({
                url: localized.resturl + '/company/toggle-activation',
                method: 'POST',
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', localized.restnonce);
                },
                dataType: 'json',
                data: {
                    entity_id: entityId,
                    action: action
                },
                success: function(result) {
                    if (result.success) {
                        // Reload the page to reflect changes
                        location.reload();
                    } else {
                        // Show error message with toastr if available, otherwise use alert
                        if (typeof toastr !== 'undefined') {
                            toastr.error(result.message || 'Failed to ' + action, 'Error');
                        } else {
                            alert(result.message || 'Failed to ' + action);
                        }
                        
                        // Restore button state
                        button.prop('disabled', false);
                        button.html(originalHtml);
                    }
                },
                error: function(xhr, status, error) {
                    // Show error message
                    if (typeof toastr !== 'undefined') {
                        toastr.error('Failed to ' + action + ': ' + error, 'Error');
                    } else {
                        alert('Failed to ' + action + ': ' + error);
                    }
                    
                    // Restore button state
                    button.prop('disabled', false);
                    button.html(originalHtml);
                }
            });
        });
    }
}

/*	-----------------------------------------------------------------------------------------------
	Staff Member Role - Single Checkbox Selection
--------------------------------------------------------------------------------------------------- */
rrspClient.staffMemberRole = {
    init() {
        this.setEventListeners();
    },

    setEventListeners() {
        $('.staff-member-role input[type="checkbox"]').on('change', function() {
            var $container = $(this).closest('.staff-member-role');
            $container.find('input[type="checkbox"]').not(this).prop('checked', false);
        });
    }
}

/*	-----------------------------------------------------------------------------------------------
	Download Accreditation Certificate
--------------------------------------------------------------------------------------------------- */
rrspClient.downloadCertificate = {
    init() {
        this.setEventListeners();
    },

    setEventListeners() {
        // Listen for click on download certificate buttons
        $(document).on('click', '.download-certificate-btn', async function(e) {
            e.preventDefault();

            const button = $(this);
            const facilityId = button.data('facility-id');

            if (!facilityId) {
                if (typeof toastr !== 'undefined') {
                    toastr.error('Facility ID is required', 'Error');
                } else {
                    alert('Facility ID is required');
                }
                return;
            }

            // Disable button and show loading state
            button.prop('disabled', true);
            const originalHtml = button.html();
            button.html('<i class="fa fa-spinner fa-spin"></i> Generating...');

            try {
                // Generate and download the certificate
                await generateAccreditationCertificate(
                    facilityId,
                    localized[REST_URL_KEY],
                    localized[REST_NONCE_KEY]
                );

                // Show success message
                if (typeof toastr !== 'undefined') {
                    toastr.success('Certificate downloaded successfully', 'Success');
                }

            } catch (error) {
                console.error('Error downloading certificate:', error);
                // Error handling is done in generateAccreditationCertificate
            } finally {
                // Restore button state
                button.prop('disabled', false);
                button.html(originalHtml);
            }
        });
    }
}

/**
 * Is the DOM ready
 *
 * this implementation is coming from https://gomakethings.com/a-native-javascript-equivalent-of-jquerys-ready-method/
 *
 * @param {Function} fn Callback function to run.
 */
function rrspDomReady( fn ) {
	if ( typeof fn !== 'function' ) {
		return;
	}

	if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {
		return fn();
	}

	document.addEventListener( 'DOMContentLoaded', fn, false );
}

rrspDomReady( () => {
	rrspClient.setNavPageActive.init();
	rrspClient.setSidebarPageActive.init();
	rrspClient.notificationBanner.init();
	rrspClient.expandableTable.init();
    rrspClient.enhancedMultiSelect.init();
    rrspClient.tooltips.init();
    rrspClient.toggleActivation.init();
    rrspClient.staffMemberRole.init();
    rrspClient.downloadCertificate.init();
} );
